import React, { createContext, useContext, useState, useCallback } from 'react';

type TabType = 'info' | 'security' | 'role';

interface ProfileModalContextType {
  isOpen: boolean;
  activeTab: TabType;
  openProfile: (tab?: TabType) => void;
  closeProfile: () => void;
  setActiveTab: (tab: TabType) => void;
}

const ProfileModalContext = createContext<ProfileModalContextType | undefined>(undefined);

export function ProfileModalProvider({ children }: { children: React.ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const [activeTab, setActiveTab] = useState<TabType>('info');

  const openProfile = useCallback((tab: TabType = 'info') => {
    setActiveTab(tab);
    setIsOpen(true);
  }, []);

  const closeProfile = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <ProfileModalContext.Provider
      value={{
        isOpen,
        activeTab,
        openProfile,
        closeProfile,
        setActiveTab,
      }}
    >
      {children}
    </ProfileModalContext.Provider>
  );
}

export function useProfileModal() {
  const context = useContext(ProfileModalContext);
  if (context === undefined) {
    throw new Error('useProfileModal must be used within a ProfileModalProvider');
  }
  return context;
}
